import React from 'react';
import './Footer.css';

function Footer() {
  return (
    <footer className="app-footer">
      <p>&copy; 2024 Quiz App. All Rights Reserved.</p>
    </footer>
  );
}

export default Footer;
